import React, { useState, useEffect } from 'react';
import InputField from '../../../../forms/inputField';
import { updateUser } from '../../../../../client/users';
import { MODALS } from '../../../../../config/images';
const ModalEditAdmin = ({ showModal, user, onClose, onSave, setSuccessMessage, setShowModalSuccess }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      setFormData({
        fullName: user.fullName || '',
        phone: user.phone || ''
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const updateData = {
        roleId: 1,
        name: formData.fullName,
        contact_number: formData.phone ? parseInt(formData.phone) : null
      };


      const response = await updateUser(user.id, updateData);
      
      if (response.status === 200) {
        setSuccessMessage('Usuario administrador actualizado correctamente');
        setShowModalSuccess(true);
        onSave({
          ...user,
          name: formData.fullName,
          contact_number: formData.phone
        });
        onClose();
      }
    } catch (err) {
      console.error('Error al actualizar usuario:', err);
      setError(err.response?.data?.message || 'Error al actualizar el usuario');
    } finally {
      setLoading(false);
    }
  };


  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[90%] sm:w-[50%] md:w-[40%] lg:w-[30%] max-h-[80vh] overflow-y-auto bg-white rounded-2xl">
        <div className="flex justify-end w-full p-2 ">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='px-6 pb-4'>
            <h2 className="text-2xl font-itcbold text-blue">Editar Usuario Administrador</h2>
    
    
            <form onSubmit={handleSubmit} className="flex flex-col gap-2 pt-4">
            
                <InputField
                  title="Nombre completo"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  validation="letters-only"
                  placeholder="Ingrese nombre completo"
                  horizontal={false}
                  required={true}
                />
                <InputField
                  title="Número de contacto"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  type="tel"
                  validation="phone"
                  placeholder="Ingrese número de contacto"
                  maxLength={9}
                  horizontal={false}
                />
              
              <div className="flex items-center justify-center pt-4 space-x-3">
                <button
                  type="button"
                  onClick={onClose}
                  disabled={loading}
                  className="px-4 py-2 w-[120px] text-gray-700 border border-gray-300 rounded-md font-itcmedium hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 w-[120px] text-white rounded-md font-itcmedium bg-blue"
                >
                  {loading ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </form>
        </div>
      </div>
    </div>
  );
};

export default ModalEditAdmin;